module.exports = __webpack_public_path__ + "Averta.5ee63a5ea3c608bd7ffc.woff";


//////////////////
// WEBPACK FOOTER
// /Users/nolanclark/Desktop/Development/GoPark/src/fonts/Averta.woff
// module id = ../../../../../src/fonts/Averta.woff
// module chunks = styles